<template>
  <div class="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
    <header class="mb-8">
      <h1 class="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
        Gerenciamento de Usuários
      </h1>
      <p class="mt-2 text-sm text-slate-600 dark:text-slate-400">
        Adicione, edite e gerencie os usuários do sistema de forma centralizada.
      </p>
    </header>

    <div class="mb-6 flex flex-col sm:flex-row justify-between items-center gap-4">
      <button @click="openAddModal"
        class="w-full sm:w-auto flex items-center justify-center bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2.5 px-5 rounded-lg shadow-sm hover:shadow-lg transition-transform hover:scale-105 duration-300 ease-in-out">
        <span class="material-symbols-outlined mr-2">person_add</span>
        Adicionar Usuário
      </button>
      <div class="w-full sm:w-64">
        <label for="filtroFuncao" class="sr-only">Filtrar por Função</label>
        <select id="filtroFuncao" v-model="filtroRole"
          class="form-select w-full px-3 py-2.5 text-sm bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 rounded-lg transition ease-in-out focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/50">
          <option value="">Todas as Funções</option>
          <option value="USER">Usuário</option>
          <option value="ADMIN">Administrador</option>
        </select>
      </div>
    </div>

    <div class="bg-white dark:bg-slate-800 shadow-lg rounded-xl overflow-hidden ring-1 ring-slate-900/5">
      <div class="overflow-x-auto">
        <table class="w-full min-w-[700px] text-sm">
          <thead class="bg-slate-50 dark:bg-slate-900/50 text-xs text-slate-500 dark:text-slate-400 uppercase tracking-wider">
            <tr>
              <th scope="col" class="px-6 py-3 font-medium">Usuário</th>
              <th scope="col" class="px-6 py-3 font-medium">Contato</th>
              <th scope="col" class="px-6 py-3 font-medium">Função</th>
              <th scope="col" class="px-6 py-3 font-medium text-center">Ações</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-200 dark:divide-slate-700">
            <tr v-if="usuariosOrdenados.length === 0">
              <td colspan="4" class="px-6 py-16 text-center">
                <div class="flex flex-col items-center">
                  <span class="material-symbols-outlined text-5xl text-slate-400 dark:text-slate-500 mb-2">group_off</span>
                  <p class="text-slate-500 dark:text-slate-400">Nenhum usuário encontrado.</p>
                </div>
              </td>
            </tr>
            <tr v-for="usuario in usuariosOrdenados" :key="usuario.id"
              class="hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors duration-150">
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="flex flex-col">
                  <span class="font-semibold text-slate-900 dark:text-white">{{ usuario.nome || usuario.username }}</span>
                  <span class="text-xs text-slate-500 dark:text-slate-400">{{ usuario.email }}</span>
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-slate-600 dark:text-slate-300">{{ usuario.telefone || 'N/A' }}</td>
              <td class="px-6 py-4 whitespace-nowrap">
                <span :class="['px-2.5 py-1 text-xs font-semibold rounded-full inline-block', usuario.role === 'ADMIN' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/50 dark:text-purple-300' : 'bg-sky-100 text-sky-800 dark:bg-sky-900/50 dark:text-sky-300']">
                  {{ usuario.role === 'ADMIN' ? 'Administrador' : 'Usuário' }}
                </span>
              </td>
              <td class="px-6 py-4 text-center whitespace-nowrap">
                <button @click="openEditModal(usuario)" title="Editar Usuário"
                  class="p-2 text-slate-500 hover:text-sky-600 dark:hover:text-sky-400 rounded-full hover:bg-sky-100 dark:hover:bg-slate-700 transition-colors">
                  <span class="material-symbols-outlined text-xl">edit</span>
                </button>
                <button @click="excluir(usuario.id)" title="Excluir Usuário"
                  class="p-2 ml-2 text-slate-500 hover:text-red-600 dark:hover:text-red-500 rounded-full hover:bg-red-100 dark:hover:bg-slate-700 transition-colors">
                  <span class="material-symbols-outlined text-xl">delete</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <transition name="modal-fade">
      <div v-if="exibeModal" @click.self="fecharModal"
        class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4">
        <div class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-2xl transform transition-all">
          <header class="px-6 py-4 border-b dark:border-slate-700 flex justify-between items-center">
            <h3 class="text-xl font-semibold text-slate-800 dark:text-slate-100">
              {{ editando ? 'Editar Usuário' : 'Adicionar Novo Usuário' }}
            </h3>
            <button @click="fecharModal" title="Fechar modal"
              class="p-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
              <span class="material-symbols-outlined">close</span>
            </button>
          </header>

          <form @submit.prevent="salvar" class="p-6">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
              <div class="sm:col-span-2">
                <label for="nome" class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Nome Completo</label>
                <input id="nome" v-model="form.nome" type="text" required placeholder="Ex: João da Silva"
                  class="form-input w-full px-3 py-2 text-sm bg-white dark:bg-slate-700/50 border border-slate-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500" />
              </div>
              <div>
                <label for="username" class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Nome de Usuário</label>
                <input id="username" v-model="form.username" type="text" required placeholder="Ex: joao.silva"
                  class="form-input w-full px-3 py-2 text-sm bg-white dark:bg-slate-700/50 border border-slate-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500" />
              </div>
              <div>
                <label for="email" class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Email</label>
                <input id="email" v-model="form.email" type="email" required placeholder="joao.silva@email.com"
                  class="form-input w-full px-3 py-2 text-sm bg-white dark:bg-slate-700/50 border border-slate-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500" />
              </div>
              <div class="sm:col-span-2">
                <label for="telefone" class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Telefone</label>
                <input id="telefone" v-model="form.telefone" type="tel" placeholder="(XX) XXXXX-XXXX"
                  class="form-input w-full px-3 py-2 text-sm bg-white dark:bg-slate-700/50 border border-slate-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500" />
              </div>
              <div class="sm:col-span-2">
                <label for="password" class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
                  Senha
                  <span v-if="!editando" class="text-red-500 text-xs">* Obrigatória</span>
                  <span v-else class="text-xs text-slate-500">(Deixe em branco para não alterar)</span>
                </label>
                <input id="password" v-model="form.password" :required="!editando" type="password"
                  class="form-input w-full px-3 py-2 text-sm bg-white dark:bg-slate-700/50 border border-slate-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500" />
              </div>
              <div class="sm:col-span-2">
                <label for="role" class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Função (Role)</label>
                <select id="role" v-model="form.role" required
                   class="form-select w-full px-3 py-2 text-sm bg-white dark:bg-slate-700/50 border border-slate-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500">
                  <option value="USER">Usuário</option>
                  <option value="ADMIN">Administrador</option>
                </select>
              </div>
            </div>

            <footer class="pt-6 mt-6 border-t dark:border-slate-700 flex justify-end gap-3">
              <button @click="fecharModal" type="button"
                class="px-5 py-2.5 text-sm font-semibold text-slate-700 dark:text-slate-200 bg-white hover:bg-slate-50 dark:bg-slate-700 dark:hover:bg-slate-600 rounded-lg ring-1 ring-slate-200 dark:ring-slate-600 transition-colors">
                Cancelar
              </button>
              <button type="submit" :disabled="salvando"
                class="px-5 py-2.5 text-sm font-semibold text-white bg-purple-600 hover:bg-purple-700 rounded-lg disabled:opacity-70 disabled:cursor-not-allowed flex items-center shadow-sm">
                <span v-if="salvando" class="material-symbols-outlined animate-spin mr-2 text-xl">progress_activity</span>
                {{ salvando ? 'Salvando...' : (editando ? 'Atualizar Usuário' : 'Criar Usuário') }}
              </button>
            </footer>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'

const API_URL = 'https://backend.controlease.com.br/api/users'
const usuarios = ref([])
const filtroRole = ref('')
const exibeModal = ref(false)
const editando = ref(false)
const salvando = ref(false)
const form = ref({ id: null, username: '', email: '', nome: '', telefone: '', password: '', role: 'USER' })

const authConfig = () => {
  const token = localStorage.getItem('token');
  if (token) {
    return { headers: { Authorization: `Bearer ${token}` } };
  }
  return {};
}

const carregarUsuarios = async () => {
  try {
    const { data } = await axios.get(API_URL, authConfig())
    usuarios.value = data
  } catch (error) {
    console.error('Erro ao carregar usuários:', error);
    alert("Falha ao carregar usuários.");
  }
}

const resetForm = () => {
  form.value = { id: null, username: '', email: '', nome: '', telefone: '', password: '', role: 'USER' };
  editando.value = false;
}

const openAddModal = () => {
  resetForm();
  exibeModal.value = true
}

const openEditModal = (usuario) => {
  form.value = { ...usuario, password: '' };
  editando.value = true;
  exibeModal.value = true
}

const fecharModal = () => {
  exibeModal.value = false
  if (!salvando.value) {
    resetForm();
  }
}

const salvar = async () => {
  if (salvando.value) return
  if (!editando.value && (!form.value.password || form.value.password.trim() === '')) {
    alert('O campo Senha é obrigatório ao adicionar um novo usuário.');
    return
  }
  salvando.value = true

  const payload = { ...form.value }
  if (editando.value && (!payload.password || payload.password.trim() === '')) {
    delete payload.password
  }

  try {
    if (editando.value) {
      const { data: usuarioAtualizado } = await axios.put(`${API_URL}/${payload.id}`, payload, authConfig())
      const index = usuarios.value.findIndex(u => u.id === usuarioAtualizado.id);
      if (index !== -1) {
        usuarios.value[index] = usuarioAtualizado;
      }
    } else {
      const { data: novoUsuario } = await axios.post(API_URL, payload, authConfig())
      usuarios.value.push(novoUsuario);
    }
    fecharModal();
  } catch (error) {
    console.error('Erro ao salvar usuário:', error)
    alert('Erro ao salvar usuário. Verifique os dados e tente novamente.')
  } finally {
    salvando.value = false
  }
}

const excluir = async (id) => {
  if (confirm('Tem certeza que deseja excluir este usuário? Esta ação não pode ser desfeita.')) {
    try {
      await axios.delete(`${API_URL}/${id}`, authConfig());
      usuarios.value = usuarios.value.filter(u => u.id !== id);
    } catch (error) {
      console.error('Erro ao excluir usuário:', error);
      alert('Erro ao excluir usuário.');
    }
  }
}

const usuariosFiltrados = computed(() => {
  if (!filtroRole.value) {
    return usuarios.value;
  }
  return usuarios.value.filter(u => u.role === filtroRole.value);
});

const usuariosOrdenados = computed(() => {
  return [...usuariosFiltrados.value].sort((a, b) => {
    return (a.nome || a.username || '').localeCompare(b.nome || b.username || '');
  });
});

onMounted(carregarUsuarios)
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .transform,
.modal-fade-leave-active .transform {
    transition: all 0.3s ease-in-out;
}

.modal-fade-enter-from .transform,
.modal-fade-leave-to .transform {
  transform: scale(0.95) translateY(-20px);
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>